import { render } from "./joinPartener.vue?vue&type=template&id=069dccbf"
import script from "./joinPartener.vue?vue&type=script&lang=js"
export * from "./joinPartener.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__